import styled from 'styled-components';
import { rgba } from 'polished';
import { containerPaddingS, containerPaddingM, containerPaddingL } from 'common/styles/variables';
import { SuiContainer, SuiInfiniteScroll, SuiSlide } from '@splashthat/sui';

export const Slide = styled(SuiSlide)`
    height: 100%;
    width: 100%;
    overflow: hidden;
`;

export const InfiniteScrollContainer = styled(SuiInfiniteScroll)`
    overflow: scroll;
    flex-wrap: wrap;

    .SuiContainer {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const NavBar = styled(SuiContainer)`
    align-self: flex-start;
    padding-right: ${containerPaddingL};
    padding-top: ${containerPaddingM};
    height: 100%;
    overflow: auto;
    flex: 0 0 170px;
`;

export const StockImageListContainer = styled(SuiContainer)`
    flex-wrap: wrap;
`;

export const StockImageAttributionContainer = styled(SuiContainer)`
    position: absolute;
    left: ${containerPaddingS};
    bottom: ${containerPaddingS};
    transform: translate(0, 20%);
    opacity: 0;
    transition: transform 0.15s ease-in, opacity 0.15s ease-in;
    text-align: center;
    background-color: ${({ theme }) => rgba(theme.palette.grayscale.black, 0.5)};
    padding: ${containerPaddingS};
    border-radius: ${containerPaddingS};

    &:hover {
        transform: translate(0, 0);
        opacity: 1;
    }
`;

export const StockImageAttributionLink = styled.a`
    color: ${({ theme }) => theme.palette.grayscale.white};

    &:hover {
        color: ${({ theme }) => theme.palette.grayscale.gray10};
    }
`;

export const StockImageContainer = styled.div`
    position: relative;
    flex-grow: 1;
    width: 33%;
    height: 25%;
    min-height: 200px;
    background-color: ${({ theme }) => theme.palette.grayscale.gray10};
    cursor: pointer;
    border: solid 2px ${({ theme }) => theme.palette.grayscale.gray2};
    overflow: hidden;
`;

export const Image = styled.img`
    height: 100%;
    width: 100%;
    object-fit: cover;

    &:hover {
        box-shadow: 0 0 0 2px ${({ theme }) => theme.palette.primary.main} inset;

        + ${StockImageAttributionContainer} {
            transform: translate(0, 0);
            opacity: 1;
        }
    }
`;

export const StockSlideContentContainer = styled(SuiContainer)`
    overflow: hidden;
`;
